import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { TextField } from '@material-ui/core';
import { Button } from '@mui/material';
import { Backdrop, CircularProgress } from '@mui/material';
import {  InputLabel,  MenuItem,  Select } from '@material-ui/core';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
//import { Field, reduxForm } from 'redux-form'
import axios from 'axios';
const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/create";


export default function UpdateHistoryNurse(props) {
   
  
     // const [body, setBody] = useState({ valoration: '', objective: '', activity: '', therapy: '', conclusion:'' })
     const [body, setBody] = useState(props.affiliateInfo.evolutions[props.indexEvolution]);
     const handleChange = e => {
		setBody({
			...body,
			[e.target.name]: e.target.value
		})
	}

    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["assessmentDate"]: newValue
        })
    };

    const [evolutionToCut, setPreviousEvolutions] = useState(props.affiliateInfo.evolutions);
    const previousEvolutions = evolutionToCut.filter(evolution => evolution.id != null);
    const [indexEvolution, setIndexEvolution] = useState(-1);
    const changeOfEvolutions = e => {
        const {value } = e.target;
        //console.log("value of evolutions es ____ " + value);
        setIndexEvolution(value);
        if(value == -1) {
            setBody(props.affiliateInfo.evolutions[props.indexEvolution]);
        } else {
            setBody(props.affiliateInfo.evolutions[value]);
        }
       
    }

    const [openLoader, setOpenLoader] = React.useState(false);

      const onSubmit = (props) => {
        if(indexEvolution != -1) {
            return;
        }
        props.affiliateInfo.evolutions[props.indexEvolution] = body;

        setOpenLoader(true);
        axios.post(url, props.affiliateInfo).then(response => { 
            setOpenLoader(false);
           // console.log("enviando " + JSON.stringify(props.affiliateInfo));
            props.setAffiliate(props.affiliateInfo);
            props.changeMenu(12);
          });
	 }
    return (
        <div>
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
                <Grid container spacing={1}  >

                    <Grid item xs={12} sm={6} md={4} >
                    <Box color='GrayText' fontSize={20} >
                            Nombre: {props.affiliateInfo.patient.firstName} {props.affiliateInfo.patient.secondName} {props.affiliateInfo.patient.lastName} {props.affiliateInfo.patient.secondLastName}
                    </Box>

                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20} >
                            Identificacion: {props.affiliateInfo.patient.id} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Edad:  {(new Date()).getFullYear() - (new Date(props.affiliateInfo.patient.birthday)).getFullYear()} 
                         </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Direccion:  {props.affiliateInfo.patient.address} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Sexo:  {props.affiliateInfo.patient.gender} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='assessmentDate'
                                name='assessmentDate'
                                label="Fecha Valoración de Paciente."
                                inputFormat="MM/dd/yyyy"
                                value={body.assessmentDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                        <InputLabel id="evolutionsLabel">Evoluciones</InputLabel>
                        <Select
                            labelId="evolutionsLabel"
                            id="evolutions"
                            name="evolutions"
                            defaultValue={-1}
                            label="Evoluciones"
                            onChange={changeOfEvolutions}
                        >
                            <MenuItem value={-1}> Evolucionar  </MenuItem>
                            {previousEvolutions.map((ev,index)=>{
                                return <MenuItem value={index}> {ev.assessmentDate} </MenuItem>;
                                }
                            )}
                           
                        </Select>
                        </Box>
                    </Grid>


                </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
              <form>
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6} md={4}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom >CONCLUSIONES  </Typography>
                            <TextField
                                id='valoration'
                                name='valoration'
                                value={body.valoration}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                aria-label="minimum height"
                                multiline
                                minRows={5}
                                placeholder="CONCLUSIONES"
                                fullWidth />
                       
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                      
                            <Button 
                           // type="submit" 
                            variant="contained" 
                            color="primary" 
                            display="inline" 
                            //onClick={() => buttonSave(props)}
                            onClick={() => {
                                if (indexEvolution != -1) {
                                    props.setIndexEvolution(indexEvolution);
                                    props.setAffiliate(props.affiliateInfo);
                                    props.changeMenu(12)
                                } else {
                                    
                                    onSubmit(props);
                                }
                            }}>
                                Cerrar Historia
                            </Button>
                    </Grid>
                </Grid>
                </form>
             
            </Paper>
        </Box>

<Backdrop
sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
open={openLoader}>
<CircularProgress color="inherit" />
</Backdrop>
</div>
    );
}